"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.throttle = exports.pictMimeDict = exports.assertNever = exports.throwError = exports.NotImplementedError = exports.decodeBase64 = exports.omit = exports.pick = exports.withTime = exports.wait = void 0;
exports.range = range;
const wait = (ms) => {
    return new Promise(resolve => setTimeout(resolve, ms));
};
exports.wait = wait;
const withTime = (func) => async (...args) => {
    const start = new Date();
    const ret = await func(...args);
    const end = new Date();
    const time = end.getTime() - start.getTime();
    return [time, ret];
};
exports.withTime = withTime;
function* range(start, end) {
    for (let i = start; i < end; i++) {
        yield i;
    }
}
const pick = (obj, ...keys) => {
    const ret = {};
    for (const key of keys)
        ret[key] = obj[key];
    return ret;
};
exports.pick = pick;
const omit = (obj, ...keys) => {
    const ret = { ...obj };
    for (const key of keys)
        delete ret[key];
    return ret;
};
exports.omit = omit;
const decodeBase64 = (base64) => {
    return Uint8Array.from(atob(base64), c => c.charCodeAt(0));
};
exports.decodeBase64 = decodeBase64;
class NotImplementedError extends Error {
    constructor(message) {
        super(`NotImplemented: ${message}`);
    }
}
exports.NotImplementedError = NotImplementedError;
const throwError = () => {
    throw new Error();
};
exports.throwError = throwError;
const assertNever = (x) => {
    throw new Error(`Unexpected ${typeof x} object: \r\n${JSON.stringify(x, undefined, 2)}`);
};
exports.assertNever = assertNever;
exports.pictMimeDict = {
    ".jpeg": "image/jpeg",
    ".jpg": "image/jpeg",
    ".png": "image/png",
    ".pdf": "application/pdf",
    ".bmp": "image/bmp",
    ".gif": "image/gif",
    ".svg": "image/svg+xml",
    ".tif": "image/tiff",
    ".tiff": "image/tiff",
};
const throttle = (func, waitms, initialWaitms) => {
    let timer = undefined;
    const lastArgsObj = {};
    const dispatchLastArgs = () => {
        if (lastArgsObj.args) {
            const args = lastArgsObj.args;
            lastArgsObj.args = undefined;
            func(...args);
            timer = setTimeout(dispatchLastArgs, waitms);
        }
        else {
            timer = undefined;
        }
    };
    return (...args) => {
        lastArgsObj.args = args;
        if (timer === undefined) {
            timer = setTimeout(dispatchLastArgs, initialWaitms ?? waitms);
        }
    };
};
exports.throttle = throttle;
//# sourceMappingURL=index.js.map